<template>
  <div class="group-setup">
    <v-progress-linear indeterminate color="orange" v-if="loading"></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-card>
      <v-card-title dark>
        <h3 class="ma-2 orange--text">Project Member Participants</h3>
      </v-card-title>
      <v-divider color="orange"></v-divider>
      <v-form>
        <v-row class="pa-5">
          <v-col cols="6" md="6" sm="12">
            <div class="subtitle-1">Lions Club Members</div>
            <div>{{ form.no_of_lions_members }}</div>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <div class="subtitle-1">LEO Club Members</div>
            <div>{{ form.no_of_leo_members }}</div>
          </v-col>
        </v-row>
        <v-row class="pa-5">
          <v-col cols="6" md="6" sm="12">
            <div class="subtitle-1">GST/ Regional/ District Team Member</div>
            <div>{{ form.no_of_gst_members }}</div>
          </v-col>
        </v-row>
        <v-row class="pa-5">
          <v-col cols="12" md="12" sm="12">
            <div class="subtitle-1">Community Leader (Mayor/ Grama Niladhari/ Principal/ Priest/ MOH/ PHI/ Police (DIG/ SSP/ OIC etc.)</div>
            <div>{{ form.has_community_leader ? 'Yes' : 'No' }}</div>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import Alert from "@/components/shared/Alert";
import { ProjectService } from "../../../../services/project-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "groupSetUpFrom",
  props: ["uuid"],
  components: { Alert },

  data: () => ({
    loading: false,
    errors: null,
    form: {
      no_of_lions_members: 1,
      no_of_leo_members: 0,
      no_of_gst_members: 0,
      has_community_leader: false,
    },
  }),

  mounted() {
    this.getProjectInfo();
  },

  methods: {
    getProjectInfo() {
      if (this.uuid !== null) {
        this.loading = true;
        ProjectService.getProjectInfo(this.uuid)
          .then((response) => {
            this.loading = false;
            if (response.data.data) {
              this.form.no_of_lions_members = response.data.data.no_of_lions_members || 1;
              this.form.no_of_leo_members = response.data.data.no_of_leo_members || 0;
              this.form.no_of_gst_members = response.data.data.no_of_gst_members || 0;
              this.form.has_community_leader = response.data.data.has_community_leader || false;
            }
          })
          .catch((error) => {
            this.loading = false;
            if (error.response) {
              let data = error.response.data;
              let errorOutput = checkError.errorFormatting(data);
              this.errors = errorOutput;
            }
          });
      }
    },

    onDismissed() {
      this.errors = null;
    },
  },
};
</script>
